import { Align } from '@progress/kendo-angular-popup';
import { Component, DestroyRef, ElementRef, inject, ViewChild } from '@angular/core';
import { calculateDateStrings } from '../../../../functions/helpers/date-difference';
import { NgZone } from '@angular/core';
import { DocumentEventsService } from 'src/app/shared/services/document-events/document-events.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  template: '',
  standalone: true,
  imports: []
})
export abstract class HeaderPopupBase {

  public calculateDateStrings = calculateDateStrings;
  public anchorAlign: Align = { horizontal: 'right', vertical: 'bottom' };
  public popupAlign: Align = { horizontal: 'right', vertical: 'top' };
  public showPopup = false;
  protected documentEventsService: DocumentEventsService = inject(DocumentEventsService);
  protected ngZone: NgZone = inject(NgZone);
  protected destroyRef: DestroyRef = inject(DestroyRef);

  @ViewChild('anchor') public anchor: ElementRef;
  @ViewChild('popup', { read: ElementRef }) public popup: ElementRef;

  public constructor() {
    this.documentEventsService.documentClickEvent.
      pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
          (event: Event) => {
            if(event?.target && this.checkHandleClick(event.target)) {
                this.ngZone.run(() => { this.onDocumentClick() });
            }
      });
  }

  public checkHandleClick(target: EventTarget): boolean {
    return this.showPopup && 
      !this.popup.nativeElement.contains(target as Node) && 
      !this.anchor.nativeElement.contains(target as Node);
  }

  /**
   * Closes the popup if the user clicks outside the popup or anchor.
   * @param event
   */
  public onDocumentClick(): void {
    this.togglePopup(false);
  }

  /**
   * Toggles the popup by flipping the value of showPopup.
   * If value is given, sets showPopup to that value.
   * @param value - Optional value to set showPopup to.
   */
  public togglePopup(value?: boolean): void {
    this.showPopup = value != undefined ? value : !this.showPopup;
  }
}
